import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { OddsTicker } from './components/OddsTicker';
import { Problems } from './components/Problems';
import { Services } from './components/Services';
import { StatsTable } from './components/StatsTable';
import { Testimonials } from './components/Testimonials';
import { Team } from './components/Team';
import { Pricing } from './components/Pricing';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-[#0a1a0f]" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <OddsTicker data-id="element-3" />
      <Problems data-id="element-4" />
      <Services data-id="element-5" />
      <StatsTable data-id="element-6" />
      <Testimonials data-id="element-7" />
      <Team data-id="element-8" />
      <Pricing data-id="element-9" />
      <Contact data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}